import React, { FC } from "react"
import { Close, Star } from "@mui/icons-material"
import { Avatar, Button, Drawer } from "@mui/material"
import { KyzzenUser } from "../../../types"
import AppTable from "../../../components/Tables/AppTable"
import { cls } from "../../../utils"

type Props = {
  isModalOpen: boolean
  closeModal: () => void
  user: KyzzenUser | null
  onDeleteUser: (user: KyzzenUser) => void
}

const UserDrawer: FC<Props> = ({
  isModalOpen,
  closeModal,
  user,
  onDeleteUser,
}) => {
  return (
    <Drawer
      anchor="right"
      open={isModalOpen}
      onClose={closeModal}
      classes={{
        paper:
          "w-full max-w-[768px] bg-kyzzen-primary text-white border-l border-kyzzen-secondary",
      }}
      slotProps={{ backdrop: { className: "#1919191E" } }}
    >
      <header className="p-6 border-b border-kyzzen-secondary flex items-center justify-between">
        <h1 className="text-2xl font-semibold">User details</h1>
        <button onClick={closeModal}>
          <Close />
        </button>
      </header>
      {user && (
        <main className="p-5 flex flex-col gap-8">
          <div className="flex items-center gap-4">
            <Avatar src={user?.thumbnail_url} sx={{ width: 60, height: 60 }} />
            <span className="text-lg  font-medium">{user.username}</span>
          </div>
          <div className="flex flex-col gap-4">
            <h3 className="text-xl font-semibold">Socials</h3>
            <SocialTable user={user} />
          </div>
          <div className="flex flex-col gap-4">
            <h3 className="text-xl font-semibold">Wallets</h3>
            {user.wallets ? (
              <WalletTable user={user} />
            ) : (
              <div>No wallets connected</div>
            )}
          </div>
          <div className="flex flex-col gap-4">
            <h3 className="text-xl font-semibold">Referral</h3>
            <div className="flex flex-col gap-2">
              <span>Referral code: {user.referral_code}</span>
              <span>No of referrals: {user.referrer_count}</span>
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <h3 className="text-xl font-semibold">Actions</h3>
            <div className="flex items-center flex-wrap gap-2">
              <Button
                variant="outlined"
                color="error"
                onClick={() => onDeleteUser(user)}
              >
                Delete
              </Button>
            </div>
          </div>
        </main>
      )}
    </Drawer>
  )
}

type SocialTableProps = { user: KyzzenUser }
const SocialTable: FC<SocialTableProps> = ({ user }) => {
  return (
    <AppTable
      columns={[
        { label: "Provider", render: (row) => <>{row.provider}</> },
        { label: "Account", render: (row) => <>{row.account}</> },
        { label: "Status", render: (row) => <>{row.status}</> },
      ]}
      data={[
        {
          provider: "Gmail",
          account: user.email,
          status: user.email_verified ? (
            <span className="text-success-40">Subscribed to Solana Pulse.</span>
          ) : (
            <span className="text-error-40">
              Not subscribed to Solana Pulse.
            </span>
          ),
        },
        {
          provider: "X (Twitter)",
          account: user.twitter_username,
          status:
            user.twitter_verified && user.twitter_verified_ohme ? (
              <span className="text-success-40">
                Following Kyzzen and OhMeOhMy_Sol.
              </span>
            ) : (
              <div className="grid gap-1 text-sm whitespace-nowrap text-error-40">
                <p className={cls(user?.twitter_verified && "text-success-40")}>
                  {user?.twitter_verified
                    ? "Following Kyzzen."
                    : "Not following Kyzzen."}
                </p>
                <p
                  className={cls(
                    user?.twitter_verified_ohme && "text-success-40"
                  )}
                >
                  {user?.twitter_verified_ohme
                    ? "Following OhMeOhMy_Sol."
                    : "Not following OhMeOhMy_Sol yet."}
                </p>
              </div>
            ),
        },
        {
          provider: "Discord",
          account: user.discord_username,
          status: user.discord_verified ? (
            <span className="text-success-40">Joined server</span>
          ) : (
            <span className="text-error-40">Hasn't joined server</span>
          ),
        },
        {
          provider: "Telegram",
          account: user.telegram_username,
          status: user.telegram_verified ? (
            <span className="text-success-40">
              Using Kyzzen's Telegram Bot.
            </span>
          ) : (
            <span className="text-error-40">
              Haven't used Kyzzen's Telegram Bot.
            </span>
          ),
        },
      ]}
    />
  )
}

type WalletTableProps = { user: KyzzenUser }
const WalletTable: FC<WalletTableProps> = ({ user }) => {
  return (
    <AppTable
      columns={[
        {
          label: "",
          classNames: { cell: "w-[1%]" },
          render: (row) => {
            console.log("1", row)
            return row.primary ? <Star /> : row.sn
          },
        },
        {
          label: "Wallet Address",
          render: (row) => {
            console.log("2", row)
            return <>{row.wallet}</>
          },
        },
      ]}
      data={
        user?.wallets?.map((wallet) => ({
          primary: wallet.includes("primary"),
          wallet: wallet.split(":")[1] || wallet.split(":")[0],
        })) || []
      }
    />
  )
}

export default UserDrawer
